import { RoutePerformanceLogging } from '@nutrien/ddc-fe-logging-react-router-dom';
import { FC } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import Home from '../Home';
import One from '../One';
import Two from '../Two';

export const App: FC = () => {
  return (
    <BrowserRouter>
      <RoutePerformanceLogging />
      <Routes>
        <Route path={'/one'} element={<One />} />
        <Route path={'/two'} element={<Two />} />
        <Route path={'*'} element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
};
